import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "store/slices/auth";
import arriveTimeReducer from "store/slices/arriveTime";
import optionsReducer from "store/slices/options";
import paymentReducer from "store/slices/payment";
import taxiClassReducer from "store/slices/taxiClass";
import srcAddressReducer from "store/slices/srcAddress";
import dstAddressReducer from "store/slices/dstAddress";
import orderCostReducer from "store/slices/orderCost";
import orderDetailsReducer from "store/slices/orderDetails";
import pushTokenReducer from "store/slices/pushToken";
import settingsReducer from "store/slices/settings";
import clientCardsReducer from "store/slices/clientCards";
import tariffsReducer from "store/slices/tariffs";
import webordersApi from "./api";

const rootReducer = combineReducers({
  auth: authReducer,
  arriveTime: arriveTimeReducer,
  options: optionsReducer,
  payment: paymentReducer,
  taxiClass: taxiClassReducer,
  srcAddress: srcAddressReducer,
  dstAddress: dstAddressReducer,
  orderCost: orderCostReducer,
  orderDetails: orderDetailsReducer,
  pushToken: pushTokenReducer,
  settings: settingsReducer,
  clientCards: clientCardsReducer,
  tariffs: tariffsReducer,
  [webordersApi.reducerPath]: webordersApi.reducer,
});

const persistConfig = {
  key: "web-orders",
  storage,
  whitelist: ["auth", "orderDetails"],
  blacklist: [webordersApi.reducerPath],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(webordersApi.middleware),
});

export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
